import { useNavigate } from "react-router-dom";
import SiteFooter from "../components/feature/SiteFooter";
import SiteHeader from "../components/feature/SiteHeader";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-4">
        <div className="container-x flex flex-col items-center py-20 text-center">
          <div className="relative">
            <p className="font-display text-[7rem] font-black leading-none text-background-200 select-none md:text-[11rem]">
              404
            </p>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-700">
                <i className="ri-archive-drawer-line"></i>
              </span>
            </div>
          </div>
          <h1 className="mt-6 font-display text-2xl font-black text-foreground-900 md:text-3xl">
            这页旧档，好像被归档到别处了
          </h1>
          <p className="mt-3 max-w-md text-sm leading-7 text-foreground-600">
            你要找的页面在故纸瓜档里没有对应档案。可能是链接已过期，也可能它还在等待被重新考古。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <button
              onClick={() => navigate("/")}
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-home-4-line mr-2"></i>回到首页
            </button>
            <button
              onClick={() => navigate("/about#tougao")}
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-700"
            >
              找不到？投稿告诉我们
            </button>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}